import React from "react";

//SimpleBar
import { IChartTable } from "src/shared/models/IDashboards.models";
import BootstrapTable from "react-bootstrap-table-next";
import { fCurrency, fCurrencyND } from "src/helpers/generalFunctions";
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartTable[];
  tableTitle: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const TableForDashboardAcc = React.memo(({details, tableTitle, titleChartNoData, typeIcon = true }: FormProps) => {
  const columns = [
    {
      dataField: "storeName",
      text: "Sucursal",
      sort: false,
      style: {
        paddingLeft: 22
      },
      headerStyle: {
        paddingLeft: 22,
        fontSize: 12,
        fontWeight: 500
      },
    },
    {
      dataField: "value1",
      text: "Cuentas por cobrar",
      align: "left",
      sort: false,
      style: {},
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
    },   
    {
      dataField: "value3",
      text: "Cuentas por pagar",
      sort: false,
      editable: false,
      align: "left",
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
      style: {},
    },
    {
      dataField: "value4",
      text: "Utilidades",
      sort: false,
      editable: false,
      align: "left",
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      } ,
      formatter: ( 
        cellContent: any,
        item: IChartTable,
        index: number,
        extraData: number
      ) => (
        <>
        {item.valueSymbol != "" ? `${item.valueSymbol} ${fCurrency(item.value4)}` : `${fCurrencyND(item.value4)}`}        
        </>
      ),
    }  
  ];

  return (
    <React.Fragment>
      <h5 className="font-size-12 mb-3 ps-4" style={{fontFamily:"Open Sans,sans-serif", marginTop:"20px", color:"#000"}}><strong>{tableTitle}</strong></h5>
      <div className="w-100">
        <BootstrapTable
          key={"productId"}
          // defaultSorted={defaultSorted}
          classes={
            "table align-middle table-nowrap table-condensed table-hover"
          }
          headerClasses="custom-header-horizontal-borders custom-header-blue-background" // Apply custom classes
          rowStyle={{ fontSize: 10 }}
          bordered={false}
          striped={false}
          keyField="productId"
          data={details || []}
          noDataIndication={() => (
            <NoDataChart
              titleChart={tableTitle}
              titleChartNoData={titleChartNoData}
              typeIcon={typeIcon}
              showTitle={false}
            />
          )}
          columns={columns}
          condensed={true}
        />
        </div>
    </React.Fragment>
  );
});
